import { InjectionToken } from '@angular/core';

export const INITIAL_TOKEN_NAME = new InjectionToken('jwt-token-managment INITIAL_JWT_TOKEN_NAME');
export const JWT_COOKIE_NAME_LOOKUP_ORDER = new InjectionToken('jwt-token-managment JWT_COOKIE_NAME_LOOKUP_ORDER');
